import React from 'react';
interface LogoProps {
  className?: string;
}
export function Logo({
  className = ''
}: LogoProps) {
  return <div className={`flex items-center ${className}`} data-id="element-219">
      <span className="font-heading font-medium text-2xl tracking-tight text-hubble-paper" data-id="element-220">
        Hubble
      </span>
    </div>;
}